import React from "react";
import AppContainer from "./appcontainer.jsx";
import { HashRouter as Router, Route } from "react-router-dom";

const AppRouter = () => {
  // const config = "/template/react";
  return (
    <Router basename="/">
      <Route render={(props) => <AppContainer {...props} />} />
    </Router>
  );
};

export default AppRouter;
